import Utils from "@/core/utils/Utils";
import Person from "@/domains/Persons/Person";
import Partner from "@/domains/Partners/Partner";

class User extends Person {
    contractAcceptances: {userAgreement: boolean, userConfidential: boolean }
    displayCurrencyCode: string
    isAdmin: boolean
    isEmailCanBeUsedAsSender: boolean
    permissions: Array<any>

    partner: Partner

    /** Привилегированные пользователи SW которым доступен фильтр по покупателю
     * 497, 51? - ИП ООО Siberian Wellness-Namangan, Дима
     * 67 - Сибирское Здоровье, Роза
     * 1124 - Скрябина Ирина
     * 564 - Аксенова Светалана
     * 1293 - karepinasvetlana@gmail.com
     * 1486 - papina.dp@sibvaleo.com Папина Дарья, update от 18.03.2026
     * 386 - Филатова Антонина filatova.av@sibvaleo.com, update от 26.08.2026
     * 1520 - Успенская Валентина well86_07+ksz@mail.ru, updated от 22.09.2026
     */
    static privilegedSWUsers = [51, 67, 497, 564, 1124, 1293, 1486, 386, 1520];

    static fromServer(userData: any, user = new User()): User {
        super.fromServer(userData, user);

        if (Utils.isObject(userData.partner)) {
            user.partner = Partner.fromServer(userData.partner);
        }

        return user;
    }

    // Не удалять, у него есть использования, ide показывает что нет, но это враньё
    get isPrivileged() {
        return User.privilegedSWUsers.includes(this.id);
    }
}

export default User;
